const APPOINTMENT_MUTATION_TYPES = Object.freeze({
  APPEND_CUSTOMER: 'APPEND_CUSTOMER',
  APPEND_RESERVATION: 'APPEND_RESERVATION',
  APPEND_RESERVATION_MOBILE_COMP: 'APPEND_RESERVATION_MOBILE_COMP',
  CLEAR_RESERVATION: 'CLEAR_RESERVATION',
  SET_STOCK: 'SET_STOCK',
  CLEAR_STOCK: 'CLEAR_STOCK',

  SET_INITIALSTATE: 'SET_INITIALSTATE',
  SET_LICENSEPLATE: 'SET_LICENSEPLATE',
  SET_VEHICULETYPE: 'SET_VEHICULETYPE',
  SET_TIRELOCATION: 'SET_TIRELOCATION',
  SET_TIMEOFARRIVAL: 'SET_TIMEOFARRIVAL',
  SET_CHASSIE: 'SET_CHASSIE',
  SET_BODYWORKTYPE: 'SET_BODYWORKTYPE',
  SET_TIRETYPE: 'SET_TIRETYPE',
  SET_SERVICETYPE: 'SET_SERVICETYPE',
  SET_RUNFLAT: 'SET_RUNFLAT',
  SET_TIRESIZE: 'SET_TIRESIZE',
  SET_PERSONALDATA: 'SET_PERSONALDATA',
  SET_VEHICLEDATA: 'SET_VEHICLEDATA',
  SET_HASAPPOINTMENT: 'SET_HASAPPOINTMENT',
  SET_REGIONDATA: 'SET_REGIONDATA',
  SET_SEARCHWATCH: 'SET_SEARCHWATCH',
  SET_REMARK: 'SET_REMARK',
  SET_REGION: 'SET_REGION',
  SET_DEPOT: 'SET_DEPOT',
  SET_ADDRESS: 'SET_ADDRESS',
  SET_COMPANY: 'SET_COMPANY',
  SET_CAT: 'SET_CAT',
  SET_RID: 'SET_RID',
  SET_MODALTPP: 'SET_MODALTPP',
  SET_REGIONCODE: 'SET_REGIONCODE',
  SET_POSTALCODE: 'SET_POSTALCODE',

  SET_LANGUAGE: 'SET_LANGUAGE',
  SET_LOADING_STATE: 'SET_LOADING_STATE',
  SET_ERROR: 'SET_ERROR',
  SET_ERROR_SLOT: 'SET_ERROR_SLOT',
  CLEAR_ERROR_SLOT: 'CLEAR_ERROR_SLOT',
});

export default APPOINTMENT_MUTATION_TYPES;
